function podeUsuario(acao){
  const authUser=typeof firebase?.auth==='function'?firebase.auth().currentUser:null;
  const logado=!!authUser;
  if(!logado)return false; // sem autenticação, nada é permitido

  if(window.MARMORARIA_SAAS_MODE===true){
    const role=window.MarmoriaSaaS?.state.membership?.role||'';
    const isOwner=role==='owner';
    const isAdmin=['owner','admin'].includes(role);
    switch(acao){
      case 'limpar_tudo':
      case 'importar_backup':
        return isOwner;
      case 'exportar_backup':
      case 'excluir_registro':
        return isAdmin;
      case 'gerenciar_acessos':
      case 'editar_config_seguranca':
        return isOwner;
      default:
        return !!role; // qualquer membro
    }
  }else{
    // Single-tenant: owner vs. usuário autorizado (allowedEmails)
    const isOwner=!!authUser&&authUser.uid===_segurancaRemota.ownerUid;
    switch(acao){
      case 'limpar_tudo':
      case 'importar_backup':
      case 'gerenciar_acessos':
      case 'editar_config_seguranca':
        return isOwner;
      case 'exportar_backup':
      case 'excluir_registro':
        return logado; // qualquer autenticado pode excluir/exportar em single-tenant
      default:
        return logado;
    }
  }
}

